export default {
  get(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/reports?${queryString}`)
        .then(response => {
          context.commit("setReports", response.data);
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  getShoppers(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/reports/shoppers?${queryString}`)
        .then(({ data }) => {
          if (params.export) {
            resolve({ data });
          } else {
            context.commit("setReports", data.results);
            context.commit("setPagination", {
              count: data.count,
              next: data.next,
              previous: data.previous
            });
            resolve(data.results);
          }
        })
        .catch(reject);
    });
  }
};
